import React from 'react';

import FormGroup from '~/commons/components/FormGroup.jsx';
import { FontAwesomeIcon as FA } from '@fortawesome/react-fontawesome';
import { faLink } from '@fortawesome/free-solid-svg-icons/faLink';

import FieldArrayCards from '../FieldArrayCards.jsx';

const FieldRestockProductsList = ({ order }) => {
  const path = (string = '', i) => `restockItems.${i}.item.${string}`;
  return (
    <>
      <FieldArrayCards name="restockItems" disabled>
        {(s, i) => (
          <>
            <div className="row">
              <div className="col-auto ml-auto">
                <a
                  className="btn"
                  target='_blank'
                  rel="noreferrer"
                  href={`/admin/stocks/reorders/items/${s?.item?._id}`}
                >
                  <FA icon={faLink} fixedWidth />
                </a>
              </div>
            </div>
            <div className="row">
              <div className="col">
                <FormGroup
                  name={path('itemCode', i)}
                  label="Item Code"
                  disabled
                />
              </div>
              <div className="col">
                <FormGroup
                  name={path('gdn', i)}
                  label="GDN"
                  disabled
                />
              </div>
            </div>
            <div className="row">
              <div className="col">
                <FormGroup
                  name={path(order?.isTradePrice ? 'prices.tradePrice' : 'prices.retailPrice', i)}
                  label="Price"
                  disabled
                />
              </div>
              <div className="col">
                <FormGroup
                  name={path('status', i)}
                  label="Status"
                  disabled
                />
              </div>
            </div>
          </>
        )}
      </FieldArrayCards>
    </>
  );
};

export default FieldRestockProductsList;
